import { css } from '@emotion/core'
import type { DisplayColumnSetting } from '@/models/restaurant-manager'
import { restaurantHighlightTokens } from './restaurant-highlight-config'

export const restaurantTableColumnWidths: Record<DisplayColumnSetting['columnKey'], string> = {
  roomNumber: '115px',
  guestName: '130px',
  customerTags: '140px',
  stayCount: '60px',
  planName: '180px',
  mealCondition: '100px',
  accommodationDate: '100px',
  frontMemo: '180px',
  mealNote: '180px',
  spaceReservationDetails: '250px',
  subjectName: '180px',
  nights: '60px',
  unitPrice: '90px',
  quantity: '80px',
}

const restaurantTableCellPadding = '10px 12px'
const restaurantTableScrollbarWidth = 8

export const restaurantTableHeaderCellStyle = css({
  alignItems: 'center',
  display: 'flex',
  padding: '10px 16px',
})

export const restaurantTableCellStyle = css({
  alignItems: 'flex-start',
  borderRight: '2px solid #F2F2F2',
  display: 'flex',
  fontSize: 14,
  gridRow: '1 / -1',
  minHeight: 44,
  minWidth: 0,
  padding: restaurantTableCellPadding,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  ':last-child': {
    borderRight: 'none',
  },
})

// ホバー時のパネルの見た目を、セルと合わせる
export const restaurantTableTooltipPanelStyle = (columnKey: DisplayColumnSetting['columnKey']) =>
  css({
    boxSizing: 'border-box',
    // スクロール時も本文幅をセルと合わせるため、常にスクロールバー領域を確保する
    scrollbarGutter: 'stable',
    padding: restaurantTableCellPadding,
    width: `calc(${restaurantTableColumnWidths[columnKey]} + ${restaurantTableScrollbarWidth}px)`,
  })

export const restaurantTableLineCellStyle = css({
  alignItems: 'stretch',
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr)',
  gridTemplateRows: 'subgrid',
  padding: 0,
})

export const restaurantTableRowStyle = css({
  borderTop: '2px solid #F2F2F2',
  color: '#272727',
  display: 'grid',
  background: '#FFF',
})

/** 新規予約の行ハイライト */
export const restaurantRowHighlightStyle = css({
  background: restaurantHighlightTokens.row.background,
})

/** 表示項目が更新されたときのフィールドハイライト */
export const restaurantFieldHighlightStyle = css({
  color: restaurantHighlightTokens.updated.color,
  fontWeight: 'bold',
})

export const restaurantTableWrapperStyle = css({
  overflowX: 'auto',
})

export const restaurantTableStyle = css({
  width: 'max-content',
  border: '1px solid #F2F2F2',
  borderRadius: 5,
  '.header': {
    background: '#F5F5F5',
    color: '#676767',
    display: 'grid',
    fontSize: 12,
    fontWeight: 'bold',
    lineHeight: 1.2,
  },
  '.body': {
    background: '#FFF',
  },
})
